import { ListCalendarEventsByAttendeeResponse } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { ListCalendarEventsByAttendeeIO } from '../types';
import {
  UseSchedulerV3InfiniteQueryEndpointArgs,
  useSchedulerV3InfiniteQuery,
} from './use-scheduler-v3-infinite-query';

type ListCalendarEventsByAttendeePageParams = { cursor?: string };

/**
 * A hook that returns an infinite query for the `ListCalendarEventsByAttendee` endpoint.
 * @param request The request object to pass to the query. Overriding pagination fields on the request is handled by the hook.
 * @param options (optional) The options to pass to `useInfiniteQuery`.
 * @param httpOptions (optional) The http options to pass to the schema function.
 * @param requestKeysToOmitFromQueryKey (optional) - An array of keys to omit from the query key. This is useful for cases where the request object contains keys that cause issues
 * when included in the query key, such as the current timestamp.
 */
export const useListCalendarEventsByAttendeeQuery = <E = unknown, D = ListCalendarEventsByAttendeeIO['output']>({
  options,
  request,
  ...args
}: UseSchedulerV3InfiniteQueryEndpointArgs<
  'ListCalendarEventsByAttendee',
  E,
  D,
  ListCalendarEventsByAttendeePageParams
>) =>
  useSchedulerV3InfiniteQuery<'ListCalendarEventsByAttendee', E, D, ListCalendarEventsByAttendeePageParams>({
    endpointName: 'ListCalendarEventsByAttendee',
    ...args,
    request: ({ pageParam }) => {
      const requestWithPageParams: ListCalendarEventsByAttendeeIO['input'] = {
        ...request,
        cursor: pageParam?.cursor,
        limit: 10,
      };
      return requestWithPageParams;
    },
    options: {
      ...options,
      getNextPageParam: (lastPage: ListCalendarEventsByAttendeeResponse) => {
        return lastPage.nextCursor ? { cursor: lastPage.nextCursor } : undefined;
      },
    },
  });
